import { usePlan } from '../hooks/usePlan';

export default function Community() {
  const { isFree } = usePlan();
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '60vh',
      gap: '16px',
      textAlign: 'center'
    }}>
      <div style={{fontSize: '48px'}}>🚧</div>
      <h2 style={{
        fontSize: '24px',
        fontWeight: '800',
        color: 'var(--text-primary)'
      }}>
        Community — Under Development
      </h2>
      <p style={{
        fontSize: '15px',
        color: 'var(--text-secondary)',
        maxWidth: '400px',
        lineHeight: '1.6'
      }}>
        Jald aa raha hai! Yahan aap doosre traders se
        connect kar sakte hain, trade ideas share kar
        sakte hain aur ek doosre se seekh sakte hain.
      </p>
      <div style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '8px'
      }}>
        {['Trade Ideas', 'Live Discussions',
          'Leaderboard', 'Mentor Connect'].map(f => (
          <span key={f} style={{
            background: 'var(--accent-subtle)',
            color: 'var(--accent)',
            border: '1px solid var(--accent)',
            borderRadius: '100px',
            padding: '4px 14px',
            fontSize: '13px',
            fontWeight: '600'
          }}>{f}</span>
        ))}
      </div>
      {isFree && (
        <div style={{
          marginTop: 8,
          padding: '8px 16px',
          background: 'var(--accent-subtle)',
          border: '1px solid var(--accent)',
          borderRadius: 100,
          fontSize: 12,
          fontWeight: 700,
          color: 'var(--accent)',
        }}>
          🔒 Posting requires Pro plan — upgrade to participate
        </div>
      )}
      <p style={{
        fontSize: '13px',
        color: 'var(--text-muted)',
        marginTop: '8px'
      }}>
        🔔 Notify me when launched
      </p>
    </div>
  );
}
